// Какие цели (подкатегории математики) уместны для типа ученика и выбранных классов.
// ОГЭ - 9 класс, ЕГЭ - 10-11, ГВЭ - 9-11, начальная школа - 1-4; вузовские цели - только студентам.
type GoalRule = { school?: [number, number]; student?: boolean };

const RULES: Record<string, GoalRule> = {
  nachalnaya_shkola: { school: [1, 4] },
  arifmetika_i_chisla: { school: [1, 6] },
  algebra: { school: [7, 11], student: true },
  geometriya: { school: [7, 11], student: true },
  nachala_matematicheskogo_analiza_shkola: { school: [10, 11] },
  olimpiadnaya_i_uglublennaya: { school: [1, 11] },
  vysshaya_matematika_bazovyj_vuz: { student: true },
  fundamentalnaya_matematika_profilynyj_vuz: { student: true },
  podgotovka_k_shkole_i_vpr: { school: [1, 8] },
  podgotovka_k_postupleniyu_v_vuz: { school: [10, 11], student: true },
  podgotovka_repetitorov_i_uchitelej: { student: true },
  podgotovka_dlya_studentov: { student: true },
  podgotovka_k_oge: { school: [9, 9] },
  podgotovka_k_ege_bazovyj: { school: [10, 11], student: true },
  podgotovka_k_ege_profilnyj: { school: [10, 11], student: true },
  podgotovka_k_gve: { school: [9, 11] },
  podgotovka_k_olimpiadam: { school: [1, 11], student: true },
  metodicheskie_bloki: {},
};

export const isGoalAllowed = (
  goal: string,
  studentType?: string | null,
  grades?: Array<string | number> | null,
): boolean => {
  const rule = RULES[goal];
  if (!rule) return true; // неизвестную (новую) цель не прячем
  if (!studentType) return Boolean(rule.school || rule.student);
  if (studentType !== 'school') return Boolean(rule.student);
  if (!rule.school) return false;
  const nums = (grades || []).map((g) => Number(g)).filter((n) => Number.isFinite(n) && n > 0);
  if (!nums.length) return true;
  const [lo, hi] = rule.school;
  return nums.some((n) => n >= lo && n <= hi);
};
